export default __webpack_public_path__ + "static/fisheye-bc0bb909229bd538e4ac34f242ea4ec5.png";